// extracted by mini-css-extract-plugin
export default {"formWarning":"index_formWarning_y1Ctl"};